export type InputConfig = Record<string, any>

const YES_NO_NA_OPTIONS: Record<string | number, string> = {
  1: 'Yes',
  0: 'No',
  [-1]: 'N/A',
}

export const defaultInputs = (): InputConfig => ({
  sectionNoteReview: { inputType: 'section', title: 'Note Review', span: 'full' },
  NoteDateMatchesClosingDate: { inputType: 'text', type: 'date', title: 'Note Date Matches Closing Date' },
  InterestRateMatchesNexys: { inputType: 'text', type: 'number', title: 'Interest Rate Matches Nexys' },
  BorrowerNameMatchesNexys: { inputType: 'text', title: 'Borrower Name Matches Nexys' },
  BorrowerEntityStateTypeMatchesApp: {
    inputType: 'select',
    title: 'Borrower entity state and type matches application in Nexys',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  LenderNameMatchesNexys: { inputType: 'text', title: 'Lender Name matches Nexys' },
  LoanAmountMatchesNexys: {
    inputType: 'select',
    title: 'Loan Amount matches Nexys',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  LoanDutchOrNonDutch: {
    inputType: 'select',
    title: 'Loan is Dutch or Non Dutch',
    options: { Dutch: 'Dutch', 'Non Dutch': 'Non Dutch' },
    hasDefaultOption: true,
  },
  IfDutchMonthlyPaymentMatchesNexys: { inputType: 'text', title: 'If Dutch, Monthly Payment matches Nexys' },
  PPPMatchesNexys: {
    inputType: 'select',
    title: 'PPP Matches Nexys',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  LateChargeVerification: { inputType: 'text', title: 'Late Charge Verification' },
  DefaultRateVerification: { inputType: 'text', title: 'Default Rate Verification' },
  MaturityDateMatchesNexys: { inputType: 'text', type: 'date', title: 'Maturity Date Matches Nexys' },
  GuarantorMatchesNexys: {
    inputType: 'select',
    title: 'Guarantor Matches Nexys',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  PropertyAddressMatchesNexys: {
    inputType: 'select',
    title: 'Property Address Matches Nexys?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },

  sectionAllonge: { inputType: 'section', title: 'Allonge', span: 'full' },
  LoanNumber: { inputType: 'text', title: 'Loan #', readOnly: true },
  LoanDateMatchesLoanDateOnNote: { inputType: 'text', type: 'date', title: 'Loan Date Matches Loan Date on Note' },
  BorrowerMatchesBorrowerOnNote: {
    inputType: 'text',
    title: 'Borrower matches borrower on note (does not have to include entity type and state)',
  },
  PropertyAddressMatchesNote: {
    inputType: 'select',
    title: 'Property Address Matches Note?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  LoanAmountMatchesNote: {
    inputType: 'select',
    title: 'Loan Amount Matches Note',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  AllongeSignedExecutivePrincipal: {
    inputType: 'select',
    title: 'Allonge signed Executive/Principal?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  AllongeAddressedToBlank: {
    inputType: 'select',
    title: 'Allonge addressed to BLANK ?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },

  sectionAssignment: { inputType: 'section', title: 'Assignment', span: 'full' },
  AssignmentOfMortgageAddressedToBlank: {
    inputType: 'select',
    title: 'Assignment of Mortgage Addressed to Blank?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  AssignmentLoanNumberIncluded: { inputType: 'text', title: 'Loan # Included' },
  AssignmentPropertyAddressMatches: {
    inputType: 'select',
    title: 'Property Address matches Note and Allonge?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  AssignorMatchesLenderNameOnNote: {
    inputType: 'select',
    title: 'Assignor matches Lender Name on Note?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  RecordingInformationMatchesRecordedMortgage: {
    inputType: 'select',
    title: 'Recording Information if entered matches recorded mortgage?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  AssignmentSignedExecutivePrincipal: {
    inputType: 'select',
    title: 'Assignment signed Executive/Principal?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
  AssignmentIsNotarized: {
    inputType: 'select',
    title: 'Assignment is notarized?',
    options: YES_NO_NA_OPTIONS,
    hasDefaultOption: true,
  },
})
